import type { NoteDetail } from "@/core/types";
import { useCosignSupervisor } from "@/features/cosignature/hooks/useCosignSupervisor";

import { CosignRejectedAlert } from "./CosignRejectedAlert";
import { NoteStatusRow } from "./NoteStatusRow";

type ResubmittedNoteStatusProps = {
  note: NoteDetail;
};

export function ResubmittedNoteStatus({ note }: ResubmittedNoteStatusProps) {
  const { isSupervisor } = useCosignSupervisor();

  return (
    <NoteStatusRow note={note}>
      {isSupervisor && <CosignRejectedAlert noteId={note.id} />}
    </NoteStatusRow>
  );
}
